<template>
  <div class="flex flex-vertical-center flex-between step-item">
    <p class="status_label">{{ status.label }}</p>

    <form-field-switch
      v-model="status.include"
      label="Include?"
      @change="updateStatus(status)"
      is-left-label
    />
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "StepItemStatus",
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateStatus( ) {
      this.$store.commit('onboarding/updateStatus', this.status);
    }
  },
})
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.step-item {
  max-width: 440px;
  padding: 8px 0;

  &:nth-of-type(even) {
    background-color: $background;
  }
}

.status_label {
  min-width: 210px;
  padding-left: 10px;
}
</style>
